import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/rocketchat': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M486.4 107.6c119.6 76.5 119.3 221 0 297.1-77.1 50.9-179.4 62.4-264.1 47.2-95.5 91.2-201.7 49.2-222.3 37 0 0 73.1-62.1 61.2-116.5-45.4-46.4-86.5-144.6 0-232.8 11.9-54.4-61.2-116.5-61.2-116.5 20.8-12.1 127.3-54.3 222.3 37.4 84.9-15.3 187.2-3.8 264.1 47.1zM294.2 404.2c126.7 0 229.4-66.2 229.4-148.2s-102.7-148.4-229.4-148.4-229.4 66.4-229.4 148.4c0 35.8 19.5 68.5 52 94.1 9.1 29.1 3.8 62-16 98.7-0.9 1.7-1.8 3.5-2.8 5.2 15-1.3 38.2-7.9 51.7-14.7 11.1-6.3 27.5-18.5 36.6-27.4l19.8-19.1c23.6 6.3 62.7 11.4 87.1 11.4 0.3 0 0.7 0 1 0zM184.1 291.3c-0.1 0-0.4 0-0.5 0-18.6 0-34-15.1-34.3-33.7-0.7-45.4 67.8-46.4 68.5-1.1v0.5c0 0.1 0 0.2 0 0.3 0 18.6-15.1 33.8-33.7 34v0zM257.9 257.6c-0.8-45.4 67.7-46.5 68.5-1.2v0.6c0.4 45.1-67.7 45.6-68.5 0.6zM401.3 291.3c-0.1 0-0.4 0-0.5 0-18.6 0-34-15.1-34.3-33.7-0.7-45.4 67.8-46.4 68.5-1.1v0.5c0 0.1 0 0.3 0 0.4 0 18.6-15.1 33.8-33.7 33.9v0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/rocketchat.js
// module id = 997
// module chunks = 0